import { jsx as o, jsxs as l, Fragment as U } from "react/jsx-runtime";
import { Fragment as $ } from "react";
import { EDropzoneFileStatus as e } from "./types.mjs";
import { isDefined as n, isTruthy as b } from "./types3.mjs";
import { FilePresentRounded as k, CloseRounded as w, DownloadRounded as B, DeleteRounded as E, RefreshRounded as v } from "@mui/icons-material";
import { IconButton as a } from "@mui/material";
import { ProgressBar as z } from "./index89.mjs";
import { formatFileSize as D } from "./utils3.mjs";
import { Typography as f } from "./index59.mjs";
import { FileListItem as P, FileComponent as T, FileContent as L, UploadIconSlot as N, UploadIconCirle as _, FileInfo as j, FileName as A, FileControls as G } from "./styles40.mjs";
const M = {
  [e.Uploading]: "primary",
  [e.Done]: "success",
  [e.Error]: "error",
  [e.Cancelled]: "error"
}, Z = ({
  status: r,
  name: m,
  fileStyle: s,
  percent: d,
  uid: C,
  error: F,
  onDelete: t,
  onDownload: p,
  onPreview: x,
  onReload: h,
  isDisabled: i,
  size: S,
  isDownloadable: u,
  isDeletable: g
}) => {
  const c = D(S), I = r === e.Done && g, y = r === e.Done && n(p) && u, R = r === e.Error && n(h);
  return /* @__PURE__ */ o($, { children: /* @__PURE__ */ o(P, { children: /* @__PURE__ */ o(T, { $status: r, $fileStyle: s, children: /* @__PURE__ */ l(L, { children: [
    n(r) && /* @__PURE__ */ o(N, { children: /* @__PURE__ */ o(_, { $status: r, children: /* @__PURE__ */ o(
      k,
      {
        fontSize: "inherit",
        color: M[r]
      }
    ) }) }),
    r === e.Uploading ? /* @__PURE__ */ o(
      z,
      {
        value: d,
        label: m,
        description: c,
        icon: n(t) && /* @__PURE__ */ o(
          w,
          {
            sx: i ? void 0 : { cursor: "pointer" },
            onClick: i ? void 0 : t,
            "aria-label": "Cancel"
          }
        ),
        valueLabel: n(d) && `${d}%`
      }
    ) : /* @__PURE__ */ l(U, { children: [
      /* @__PURE__ */ l(j, { children: [
        /* @__PURE__ */ o(
          A,
          {
            $isDisabled: i,
            onClick: x,
            color: "text.primary",
            children: m
          }
        ),
        r === e.Error ? /* @__PURE__ */ o(f.Caption, { color: "error.main", children: F }) : b(c) && /* @__PURE__ */ o(f.Caption, { color: "text.secondary", children: c })
      ] }),
      /* @__PURE__ */ l(G, { children: [
        y && /* @__PURE__ */ o(
          a,
          {
            onClick: p,
            "aria-label": "Download",
            disabled: i,
            sx: { padding: "4px" },
            children: /* @__PURE__ */ o(B, {})
          }
        ),
        I && /* @__PURE__ */ o(
          a,
          {
            onClick: t,
            "aria-label": "Delete",
            disabled: i,
            sx: { padding: "4px" },
            children: /* @__PURE__ */ o(E, {})
          }
        ),
        R && /* @__PURE__ */ o(
          a,
          {
            onClick: h,
            "aria-label": "Reload",
            disabled: i,
            sx: { padding: "4px" },
            children: /* @__PURE__ */ o(v, {})
          }
        )
      ] })
    ] })
  ] }) }) }) }, C);
};
export {
  Z as FileUploadStatus
};
//# sourceMappingURL=index61.mjs.map
